import React, { FC } from 'react';
import styles from './FormContainer.module.css';

interface FormContainerProps {
  header: string;
}

const FormContainer: FC<FormContainerProps> = ({ children, header }) => (
  <div className={styles.FormContainer} data-testid="FormContainer">
    <div className={'border-gray-900 border rounded mb-5'}>
      <div className="bg-gray-900 text-white rounded-t p-2">
        <h5 className={'m-0 text-center text-uppercase'}>{header}</h5>
      </div>
      <div className="mx-2 my-4 m-sm-4 m-md-5">{children}</div>
    </div>
  </div>
);

export default FormContainer;
